import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import clsx from "clsx";
import CurrentInfoContext from "context/CurrentInfoContext";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectThemeDirection } from "redux/theme/theme.selectors";
import { createStructuredSelector } from "reselect";
import "./App.scss";
import DashboardLayout from "./components/DashboardLayout/DashboardLayout";

function App() {
  // const dispatch = useDispatch();
  const [currentClass, setCurrentClass] = useState(null);
  const [currentStudent, setCurrentStudent] = useState(null);
  const { themeDirection } = useSelector(
    createStructuredSelector({
      themeDirection: selectThemeDirection,
    })
  );

  // const { i18n } = useTranslation();

  // useEffect(() => {
  //   dispatch(themeDirectionFunc(i18n && i18n.language === "fa" ? "rtl" : ""));
  // }, [dispatch, i18n]);

  return (
    <CurrentInfoContext.Provider
      value={{
        currentClass: currentClass,
        currentStudent: currentStudent,
        setCurrentStudent,
        setCurrentClass,
      }}
    >
      <div className={clsx("App", themeDirection)}>
        <DashboardLayout />
      </div>
    </CurrentInfoContext.Provider>
  );
}

export default App;
